import { Emitter } from "@curefit/pandora";

export const emitter = new Emitter();
